import { listTemplateCategories } from "~/api/videoTemplate"
import type { RequestOptions } from "~/common/request"

export const loadTemplateCategoryRecords = async (
  options?: RequestOptions,
  list: typeof listTemplateCategories = listTemplateCategories,
): Promise<API.VideoTemplate.Category[]> => {
  const categories: API.VideoTemplate.Category[] = []
  const names = new Set<string>()
  let total: number | undefined
  const readPage = async (
    page: number,
  ): Promise<API.VideoTemplate.Category[]> => {
    options?.signal?.throwIfAborted()
    const { data } = await list(
      { page, page_size: 100 },
      { ...options, notify: false },
    )
    if (
      !data ||
      !Array.isArray(data.items) ||
      !Number.isInteger(data.total) ||
      data.total < 0 ||
      (total !== undefined && total !== data.total)
    )
      throw new Error("模板分类返回格式无效或已变化，请重试")
    total = data.total
    for (const item of data.items) {
      if (
        !item ||
        typeof item.category !== "string" ||
        !item.category.trim() ||
        names.has(item.category)
      )
        throw new Error("模板分类为空或重复，请重试")
      if (
        item.rank !== undefined &&
        (typeof item.rank !== "number" || !Number.isFinite(item.rank))
      )
        throw new Error("分类排序值无效，请重试")
      names.add(item.category)
      categories.push(item)
    }
    if (categories.length === total) return categories
    if (!data.items.length || categories.length > total)
      throw new Error("模板分类分页数据不完整，请重试")
    return readPage(page + 1)
  }
  return readPage(0)
}

export const loadTemplateCategories = async (
  options?: RequestOptions,
  list: typeof listTemplateCategories = listTemplateCategories,
): Promise<string[]> =>
  (await loadTemplateCategoryRecords(options, list)).map(
    (item) => item.category,
  )

export const getNextCategoryRank = (
  categories: API.VideoTemplate.Category[],
): number => {
  const rank =
    categories.reduce((maximum, item) => Math.max(maximum, item.rank ?? 0), 0) +
    1
  if (!Number.isFinite(rank)) throw new Error("分类排序值超出范围")
  return rank
}
